module.exports = window.T['undefined/changes.html'] || "<div class=\"container\"><div class=\"row\"><changelist changes=\"changes\"></changelist></div></div>";